import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';
import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { MutationOptions, MutationResult } from '../../../../shared/types/query';
import { PAGE_KEY } from './index';

export function useDeleteActionUrl(options?: MutationOptions<string, AxiosResponse>): MutationResult<string, AxiosResponse> {
  const http = useHttpClient();

  return useMutation({
    ...options,
    mutationKey: `${PAGE_KEY}/delete`,
    mutationFn: (id: string) => {
      return http.request({
        method: 'delete',
        url: `ActionUrls/${id}`,
      })
    },
  })
}